import { render, staticRenderFns } from "./InfosLogged.vue?vue&type=template&id=63b95cc6&"
import script from "./InfosLogged.vue?vue&type=script&lang=js&"
export * from "./InfosLogged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports